// extracted by mini-css-extract-plugin
export default {"link":"VD-z","disabled":"WD-z"};